import { createFileRoute } from "@tanstack/react-router";
import EquipoPanel from "@/components/admin/EquipoPanel";

export const Route = createFileRoute("/admin/equipo")({
  component: EquipoPanel,
});
